import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  productLoginRequest,
  putChangeDefaultRoleRequest,
  setCurrentProductLogin
} from '../../../../redux/actions/authentication';
import ProductsDropdown from './ProductsDropdown';

const ProductsDropdownWrapper = (props) => {
  return <ProductsDropdown {...props} />;
};

ProductsDropdownWrapper.propTypes = {
  authentication: PropTypes.object,
  productLogin: PropTypes.func,
  putChangeDefaultRole: PropTypes.func,
  setCurrentProduct: PropTypes.func
};

function mapStateToProps(state) {
  return {
    authentication: state.authentication
  };
}

function mapDispatchToProps(dispatch) {
  return {
    productLogin: (payload) => {
      dispatch(productLoginRequest(payload));
    },
    putChangeDefaultRole: (payload) => {
      dispatch(putChangeDefaultRoleRequest(payload));
    },
    setCurrentProduct: (payload) => {
      dispatch(setCurrentProductLogin(payload));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductsDropdownWrapper);
